import React from 'react';

export const ForgePioClickupSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.5 12.0837L3.90283 10.074C5.18752 11.8776 6.54357 12.7278 8.04237 12.7278C9.54117 12.7278 10.8734 11.9034 12.0867 10.0998L14.5372 12.058C12.7767 14.6345 10.5879 16 8.04237 16C5.52059 16 3.30807 14.6345 1.5 12.0837Z"
				fill="#6686FB"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.01858 4.01833L3.5572 7.70378L1.5 5.3974L8.04337 0L14.5372 5.3974L12.4552 7.68L8.01858 4.01833Z"
				fill="#FF6479"
			/>
		</svg>
	);
};
